export default __webpack_public_path__ + "static/media/teenagers.da62a1f3.webp";